export const CLIENT_TYPE = ['clientType'];
export const ID = ['id'];
export const RICH_TEXT = ['richText'];
export const SENDER = ['sender'];
export const STATUS = ['status'];
export const TEXT = ['text'];
export const TIMESTAMP = ['timestamp'];